import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer-service.demo.onyxcentersource.com',
  hostname: 'pioneer.demo.onyxcentersource.com',
  portalUrl: 'https://portal.demo.onyxcentersource.com',
  onyxCommonDataUrl: 'https://pioneer-service.demo.onyxcentersource.com/ocd/api',
  emailValidation: true
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/environments/environment.demo.ts